var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bx_top"},[_c('strong',{staticClass:"top_point green"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.writer))])]),_vm._v(" "),_c('div',{staticClass:"title_area"},[_c('h2',{staticClass:"tit_cont"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.sendDateText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }